import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractEntityGridColumnComponent } from '@entity-framework/entity-grid/state/abstract-entity-grid-column.component';
import { BureauPaymentListItem } from '@app/bureau/payments/payment-status/models/bureau-payment-list-item';

@Component({
  selector: 'app-bureau-payments-hrmc-submission-column',
  template: `
    <div>
      @if (listItem.hasHmrcSubmission === null || listItem.hasHmrcSubmission === undefined) {
        <ci-phosphor-icon name="minus" size="lg" variant="primary" />
      } @else {
        @if (listItem.hasHmrcSubmission) {
          <ci-phosphor-icon name="check-circle" size="lg" variant="success" />
        } @else {
          <ci-phosphor-icon name="x-circle" size="lg" variant="primary" />
        }
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BureauPaymentsHmrcSubmissionColumnComponent extends AbstractEntityGridColumnComponent<BureauPaymentListItem> {}
